export const isOnlyBeemobi = window.location.hostname.includes('beemobi')  
//  || window.location.hostname.includes('localhost')
 ? true : false


// WEBPACK FOOTER //
// ./src/constants/isOnlyBeemobi.js